"use client";

import { c as _c } from "react/compiler-runtime";
import { twc } from "@/helpers/twc";
import { FileCsv } from "@phosphor-icons/react/dist/ssr";
import Image from "next/image";
import React from "react";
import { AnimatedBeam } from "./AnimatedBeam";
import { FeatureContainer } from "./BentoBoxComponents";
import { LogoIcon } from "./LogoIcon";
const ICON_SIZE = 24;
const END_OFFSET = -12;
export const EasyExports = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  const containerRef = React.useRef(null);
  const logoRef = React.useRef(null);
  const sourceRef = React.useRef(null);
  const csvRef = React.useRef(null);
  const excelRef = React.useRef(null);
  const apiRef = React.useRef(null);
  const gsheetRef = React.useRef(null);
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><AnimatedBeam containerRef={containerRef} fromRef={logoRef} toRef={sourceRef} duration={3} /><AnimatedBeam containerRef={containerRef} fromRef={sourceRef} toRef={csvRef} duration={3} endYOffset={END_OFFSET} /><AnimatedBeam containerRef={containerRef} fromRef={sourceRef} toRef={excelRef} duration={3} endYOffset={END_OFFSET} /><AnimatedBeam containerRef={containerRef} fromRef={sourceRef} toRef={gsheetRef} duration={3} endYOffset={END_OFFSET} /><AnimatedBeam containerRef={containerRef} fromRef={sourceRef} toRef={apiRef} duration={3} endYOffset={END_OFFSET} /></>;
    t2 = <LogoIcon width={80} height={80} ref={logoRef} className="relative z-10 size-[68px] animate-pulse animate-infinite animate-duration-[2s] md:size-[80px]" />;
    t3 = <div className="relative z-[2] mt-4 size-3 rounded-full border border-neutral-700 bg-neutral-900/50 backdrop-blur-sm md:mt-14" ref={sourceRef} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Circle className="!bg-[#09A745]" ref={gsheetRef}><Image src="/_static/images/icons/gsheet.svg" width={ICON_SIZE} height={ICON_SIZE} alt="Google sheets" /></Circle>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Circle className="!bg-[#1C6E43]" ref={excelRef}><Image src="/_static/images/icons/xlsx.svg" width={ICON_SIZE} height={ICON_SIZE} alt="Excel" /></Circle>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Circle ref={csvRef} className="!bg-indigo-600"><FileCsv /></Circle>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative mt-6 flex flex-1 flex-col items-center md:mt-8" ref={containerRef}>{t1}{t2}{t3}<div className="z-10 mt-auto flex w-full max-w-[380px] justify-between px-2 pb-2">{t4}{t5}{t6}<Circle ref={apiRef}><span className="text-[11px] font-bold">API</span></Circle></div></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== children) {
    t8 = <FeatureContainer className="min-h-[350px]">{children}{t7}</FeatureContainer>;
    $[7] = children;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
const Circle = twc.div`flex items-center justify-center rounded-full border border-neutral-800/40 bg-neutral-900 size-12 [&_svg]:size-6 shadow-sm shadow-black/30 ring-2 ring-offset-2 ring-neutral-800 ring-offset-[#111]`;